import React from 'react';
import { ExternalLink } from 'lucide-react';
import './Publications.css';

const Publications = () => {
  const publications = [
    {
      title: 'The Ghost Town in the Machine: Why I Redesigned the Way AI Thinks',
      type: 'Featured Article',
      url: 'https://medium.com/@imsarthakshrma/the-ghost-town-in-the-machine-why-i-redesigned-the-way-ai-thinks-35aab012dec1',
      year: '2025'
    }
  ];

  return (
    <section id="publications" className="section publications-section">
      <h2 className="section-title">Writing & Publications</h2>
      
      <div className="publications-list">
        {publications.map((pub, index) => (
          <a 
            key={index} 
            href={pub.url} 
            className="publication-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="publication-content">
              <div className="publication-header">
                <span className="publication-type">{pub.type}</span>
                <span className="publication-year">{pub.year}</span>
              </div>
              <h3 className="publication-title">{pub.title}</h3>
            </div>
            <ExternalLink className="publication-icon" size={20} strokeWidth={1.5} />
          </a>
        ))}
      </div>
    </section>
  );
};

export default Publications;